import React from 'react';
import { css } from '@emotion/css';
import MuiTab, { TabProps } from '@mui/material/Tab';
import cn from 'classnames';

const tabFocusVisible = css`
  border-radius: 0.6rem;
  &.Mui-focusVisible {
    outline: 0.16rem solid transparent;
    box-shadow: inset 0 0 0 0.16rem var(--focus-secondary);
  }
`;

const BaseTab: React.FC<React.PropsWithChildren<TabProps>> = (props) => {
  return <MuiTab {...props} className={cn(tabFocusVisible, props.className)} />;
};

export default BaseTab;
